import React, { useState, useContext, useEffect, useLayoutEffect } from "react";
import RemoveIcon from "../RemoveIcon/RemoveIcon";
import SearchIcon from "../SearchIcon/SearchIcon";
import ToolComponent from "../../ToolComponent/ToolComponent";
import TreeItem from "../../TreeItem/TreeItem";
import Tree from "../../Tree/Tree";
import "../../Styles/globalStyle.css";
import { store } from "../../../store.js";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import useKeyPress from "../../../Hooks/useKeyPress";
import useSize from "../../../Hooks/useSize.js";
import useGetNestedOccurence from "../../../Hooks/useGetNestedOccurence.js";
import useGetCurrentsTools from "../../../Hooks/useGetCurrentsTools.js";
import useBuildStyle from "../../../Hooks/useBuildStyle.js";
import useSetRowData from "../../../Hooks/useSetRowData.js";
import useSetActualizeDataFromDataGrid from "../../../Hooks/useSetActualizeDataFromDataGrid";

import useBuildDataAndTree from "../../../Hooks/useBuildDataAndTree";

export default function DataGrid(props) {
  const [isDragOver, setDragover] = useState(false);
  const setActualizeDataFromDataGrid = useSetActualizeDataFromDataGrid();
  //const [rowWidth, setRowWidth] = useState(props.style.width);
  const CtrlPressed = useKeyPress(17);
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const currentToolIds = globalState.state.formData.currentTool.map(item=> item.id);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const getCurrentsTools = useGetCurrentsTools();
  const buildDataAndTree = useBuildDataAndTree();
  const buildStyle = useBuildStyle();
  const setRowData = useSetRowData();
  
  const getNestedOccurence = useGetNestedOccurence();
  const searchGridData = props.data.metaData.filter(item => item.type == "SearchGrid")[0]
  const headerData = props.data.metaData.filter(item => item.type == "Header")[0]
  const filterData = props.data.metaData.filter(item => item.type == "Filter")[0]
  const rowsData = props.data.metaData.filter(item => item.type == "Rows")[0]
  const nBaseRow = 4 // SearchBar + Headerbar + FilterBar + Rows
  const dataMenu = props.data.properties.data
  const option = dataMenu.option  && dataMenu.option.toLowerCase() 

  const [currentRow, setCurrentRow] = useState({
    id: undefined
  });

  const [pagination, setPagination] = useState({
    start: isNaN(props.data.properties.sliceStart.value) ? 1 : props.data.properties.sliceStart.value,
    end: isNaN(props.data.properties.sliceSize.value) ? 10 : props.data.properties.sliceSize.value,
    size: props.data.properties.size.value,
    actualize: props.data.properties.actualize.value,
    operations:[]
  });

  const filteredColId = pagination.operations.map(item => item.firstOperand.headerId)
    
  const isConditionChecked = (firstOperand, operator, secondOperand) => {
    
    switch (operator) {
      case "equal":
        return firstOperand == secondOperand
      case "not equal":
        return firstOperand != secondOperand
      case "greater":
        return firstOperand > secondOperand
      case "greater & equal":
        return firstOperand >= secondOperand
      case "lower":
        return firstOperand < secondOperand
      case "lower & equal":
        return firstOperand <= secondOperand
      case "contains":
        return firstOperand.includes(secondOperand)
      case "starts with":
        return firstOperand.startsWith(secondOperand)
      case "ends with":
        return firstOperand.endsWith(secondOperand)
    }
  };

  
  
  const getColumnValue = (id, metaData) => {
   
    var col = metaData.filter(item => item.headerId == id)[0]
    const textValue = col.properties.text.value
    if(typeof textValue == "object")
      return textValue.item
      
    return textValue
  };
  
  const isValidLine = (currentRow) => {

    var isValid = true
    var n = currentRow.length
    var i = 0
    
    while (isValid && i < n) {
      let currentCol = currentRow[i]
      if (filteredColId.includes(currentCol.headerId)) {
        const currentOperation = pagination.operations
          .filter(operation => operation.firstOperand.headerId == currentCol.headerId)[0]

        let operator = currentOperation.operator.item
        let filteredCol = filterData.metaData.filter(item => item.id == currentOperation.colId)[0]
      
        let firstOperand = currentCol.properties.text.value
        let secondOperand = filteredCol.properties.text.value

        firstOperand = typeof firstOperand == 'object' ? firstOperand.item : firstOperand //JSON.stringify(firstOperand)
        secondOperand = typeof secondOperand == 'object' ? secondOperand.item : secondOperand //JSON.stringify(secondOperand)

        isValid = isConditionChecked(firstOperand, operator, secondOperand)
      }
      i = i + 1
    }
    
    
   return isValid
  };


  const getFilteredRow = () => {
    var currentRows = props.data.metaData.filter(item => item.type == "Row")

    if (pagination.orderedColType)
      currentRows.sort((a,b) => getColumnValue(pagination.orderedColId, a.metaData) > getColumnValue(pagination.orderedColId, b.metaData) ? 
        (pagination.orderedColType == "asc" ? 1 : -1) : (pagination.orderedColType == "asc" ? -1 : 1)
      )
    
    return pagination.operations.length == 0 ? currentRows : currentRows.filter (row => isValidLine(row.metaData))
    
  };
  const getCurrentRow = () => {
    
    if (option == "mapping") {
      
      //if (option == "mapping" && (pagination.actualize || props.data.properties.actualize.value)) {
      return setRowData(JSON.parse(JSON.stringify(props.data))
        ,{start: pagination.start, end:pagination.end, operations:pagination.operations
        ,filteredColId:filteredColId,filterData:filterData,
        orderedColValue:pagination.orderedColValue,orderedColType:pagination.orderedColType })
    }
    else

      return getFilteredRow().slice(pagination.start -1 , pagination.end)
  };

  const rowData = getCurrentRow()
  
 
    
  useEffect(() => {
    setPagination({...pagination, size:props.data.properties.size.value})
  }, [rowData.length]);

  
  useEffect(() => {
    setPagination({...pagination, actualize:props.data.properties.actualize.value
      ,size: props.data.properties.size.value,})
      
  }, [props.data.properties.actualize.value]);
 
  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);


  const updateSelectedValues = (containers, itemSelected) => {
    if (!containers.metaData) return;
    containers.metaData.map(container => {
      if (props.data.id == container.id) { // if (itemSelected.id == container.id) {
         props.data.selectedValues.includes(itemSelected.id)
        ? updateGridValues(container,itemSelected)         
        : container.selectedValues.push(itemSelected.id);
        return;
      }
      else
      updateSelectedValues(container, itemSelected);
    });
  };

 

  const onMultiselectionClick = (itemSelected) => {
    
    var updatedFormData = JSON.parse(
      JSON.stringify(globalState.state.formData)
    );
    
    updateSelectedValues(updatedFormData,  itemSelected);
    
    dispatch({
      type: "UPDATE_FORM",
      payload: updatedFormData,
    });

   
  };

  //useEffect(() => {
  //  !globalState.state.formData.isEditTool && setRowWidth(props.style.width.value);;
  //}, [props.style.width.value]);
 
  const updateGridValues =(container, itemSelected) => {
    container.selectedValues = container.selectedValues.filter(
      (item) => item != itemSelected.id
    ) ;
  };
 
  const canAdd = (template) => {
    return isAllowedControl(template) && isNotAlreadyAdd(template.id);
  };

  const isAllowedControl = (template) => {
    
    return props.data.id != template.id && !props.data.parentId.includes(template.id) &&  !props.data.excludesDropTypes.includes(template.type) ;
  };

  const isNotAlreadyAdd = (id) => {
    return props.data.metaData.filter(item => item.type == "Header")[0]
      .metaData.filter((item) => item.id === id).length === 0;
  };

  const drop = (e, parentId) => {
    e.preventDefault();
  
    var dataTransfer = e.dataTransfer.getData("controlId");
    if (dataTransfer){
      var template = JSON.parse(dataTransfer);

      if (canAdd(template)) {
        var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
        /*template["parentId"] = [parentId, ...props.data.parentId];
        props.handleOnDrop(updatedFormData,props.data.id, template);*/
        //var rowTemplate = JSON.parse(JSON.stringify(template))
        
        //props.handleOnDrop(updatedFormData,[parentId, ...props.data.parentId], template, {type:"DataGrid"});

        props.handleOnDrop(updatedFormData,
          {id:[parentId, ...props.data.parentId], globalId:[props.data.globalId, ...props.data.parentGlobalId]}
          , template, {type:"DataGrid"});
      }
    }
    setDragover(false);
    e.stopPropagation();
  };
  
  const onClickAdd = (e, index) => {
    e.preventDefault();
  
    var template = JSON.parse(JSON.stringify(rowsData));
    
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    
    props.handleOnDrop(updatedFormData, 
      {id:[props.data.id, ...props.data.parentId], globalId:[props.data.globalId, ...props.data.parentGlobalId]}
      //[props.data.id, ...props.data.parentId]
      , {...template, id:0, type:"Row"}, {type:"Row", gridSettingsId:props.data.globalId, index:index + nBaseRow});
    
    e.stopPropagation();
  };

  const deleteRow = (containers,id, rowId, previous, size) => {
    if (!containers.metaData) return;
    containers.metaData.map((container, index) => {
     
      if (container.id == id){
        
        container.metaData = container.metaData.filter(row=> row.id != rowId) 
        
       
        previous["value"] = container.metaData[index]
        if (!previous.value) previous["value"] = rowsData

        container.properties.size.value = container.properties.size.value - 1
        size.value = container.properties.size.value
      }
      else {
        deleteRow(container, id, rowId, previous, size);
      }
    })
  };
  const onClickRemove = (e, rowId) => {
    e.preventDefault();
  
    
    var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
    //var currentsTools = [];
    var previous = {}
    var size = {}
    //getCurrentsTools(updatedFormData, currentsTools, [props.data.id]);
    
    deleteRow(updatedFormData, props.data.id, rowId, previous, size)

    setActualizeDataFromDataGrid(updatedFormData, props.data.globalId, size.value)
    
    updatedFormData.currentTool = [previous.value]
    buildDataAndTree(updatedFormData)
    dispatch({
      type: "UPDATE_FORM_WITOUT_HISTORIQUE",
      payload: updatedFormData,
    });
    
    e.stopPropagation();
  };


  const onDoubleClick = (e, template) => {
    e.preventDefault();
    
    var value = ""

    if (option == "mapping") {
      const mapping = props.data.properties.data.value.mapping
      
      const mappingRowsHeaderIds = mapping.values.filter(value => value.id == mapping.id)[0]
        .details.map(detail => {return {key:detail.key.value, value:detail.value.value
          , headerId:rowsData.metaData.filter(item => item.globalId == detail.key.value.slice(-1)[0])
                                      .map(item => item.headerId)[0]}})

    
      value = mappingRowsHeaderIds.filter(item => item.headerId == template.id).map(item => item.value)[0]
      //value = rowsData.metaData.filter(item => item.headerId == template.id)[0].properties.text.value
      
    }
    const type = pagination.orderedColType == undefined ? "asc" : (pagination.orderedColType == "asc" ? "desc" : undefined)
    
    
    setPagination({...pagination, orderedColValue:value, orderedColId:template.id,orderedColType:type})
  
  };

  
  const getStyle = () => {
    var newStyle = buildStyle(props.style);
    
    //newStyle["top"] = top.total;
    newStyle["border"] = isDragOver
      ? "2px dashed #1f79e1"
      : props.draggable && props.isSelected
      ? "1px dashed gray"
      : props.style.border.value;

    if (!props.draggable) newStyle["resize"] = "none" 
    return newStyle;
  };
  

  const onClickPagination = (newPagination) => {
    setPagination({...pagination, ...newPagination})
  };

  const onSelectOperator = (details) => {
    setPagination({...pagination, operations:details})
  };

  const updateOccurenceValue = (containers, id, data) => {
    if (!containers.metaData) return;
    containers.metaData.map(item => {
      if (id == item.id) {
        item.metaData = data;
        return;
      }
      else
      updateOccurenceValue(item, id, data);
    });
  };

  const shiftColumn = (updatedFormData, columnSource, columnDestinationId, type) => {
    var metaData = [];

    var container = props.data.metaData.filter(item => item.type == type)[0]
    getNestedOccurence(updatedFormData, container.id, metaData);
    
    

    metaData = metaData.flat(1);
    
    var destinationIndex = -1;
    metaData.map((val, index) => {
    if (val.id == columnDestinationId) destinationIndex = index;
    });
  
   
    metaData = metaData.filter(
    (item) => item.id != columnSource.id
    );
   
    var data = [
    ...metaData.slice(0, destinationIndex),
    ...[columnSource],
    ...metaData.slice(destinationIndex ),
    ]
    
    updateOccurenceValue(updatedFormData, container.id, data)
  };
  const onDropColumn = (e, columnDestination, parentId) => {
    var columnSource = JSON.parse(e.dataTransfer.getData("controlId"));
    
    if (isAllowedControl(columnSource))
      if (isNotAlreadyAdd(columnSource.id)) {
        
        drop(e, parentId);
      } else {
        var updatedFormData = JSON.parse(
          JSON.stringify(globalState.state.formData)
        );
        if (columnDestination.id !== columnSource.id) {

          shiftColumn(updatedFormData, columnSource, columnDestination.id, "Header")

          const rowColumnSource = props.data.metaData.filter(item => item.type == "Rows")[0].metaData.filter(item => item.headerId == columnSource.id)[0]
          const rowColumnDestination = props.data.metaData.filter(item => item.type == "Rows")[0].metaData.filter(item => item.headerId == columnDestination.id)[0]
          shiftColumn(updatedFormData, rowColumnSource, rowColumnDestination.id, "Rows")

          const filterColumnSource = props.data.metaData.filter(item => item.type == "Filter")[0].metaData.filter(item => item.headerId == columnSource.id)[0]
          const filterColumnDestination = props.data.metaData.filter(item => item.type == "Filter")[0].metaData.filter(item => item.headerId == columnDestination.id)[0]
          shiftColumn(updatedFormData, filterColumnSource, filterColumnDestination.id, "Filter")
          updatedFormData.currentTool = [columnSource];

          dispatch({
            type: "UPDATE_FORM",
            payload: updatedFormData,
          });
        }
      setDragover(false);
      e.stopPropagation();
    }
  };
  
  const onClick = (e, id) => {
    
      var updatedFormData = JSON.parse(
        JSON.stringify(globalState.state.formData)
      );
      var alreadyClick = currentToolIds.includes(props.data.id);

      if (CtrlPressed.keyPressed == true){
        if (alreadyClick)
          updatedFormData.currentTool = updatedFormData.currentTool.filter(item => item.id != props.data.id);
        else
          updatedFormData.currentTool.push(props.data);
      }
      else
        updatedFormData.currentTool = [props.data];
      

      dispatch({
        type: "UPDATE_FORM",
        payload: updatedFormData,
      });
    
    e.stopPropagation();
  };

  const getColumns = () => {
   
    return headerData.metaData.map((col) => {
      return { id: col.id, item: col.properties.text.value , width: col.styles.width.value.slice(0,-2)};
    });
  };
  //const setWidth = (e) => {
    
    //setRowWidth(parseInt(e.target.scrollLeft) + parseInt(props.style.width.value.slice(0,-2)) + "px");
    /*setRowWidth(parseInt(e.target.scrollLeft) + parseInt(props.style.minWidth.slice(0,-2)) + "px");*/
  //};

  const updateSize = (id, resizeWidth, resizeHeight) => {
    
   // if (isHeader)
      props.updateSize(id, resizeWidth, resizeHeight)
    //else props.updateSize(id, resizeWidth, resizeHeight)
   
  };

  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
    e.stopPropagation();
  };
  
  /*const getCurrentData = () => {

    let option = props.data.option && props.data.option.filter(item => item.type == "properties" && item.menu == "data")[0]
    let current = props.data.properties.data.value
    var currentData = []
    if (option)
      currentData = current[option.value.toLowerCase()].values ? 
      current[option.value.toLowerCase()]
        .values.filter(item => item.id == current[option.value.toLowerCase()].id)[0]
          .details.map(detail => {return {id:detail.key.value, item:detail.value.value}}) : []
    else
      currentData = props.data.metaData.filter(item => item.isTemplate == true)
    
    
    return currentData
  };*/

  /*const isCurrentRow = (data) => {
    
    return currentRow.id == data.id || 
      data.metaData.filter(item => currentRow.id == item.id).flat(Infinity).length > 0
    
  };*/

  const isCurrentRow = (data) => {
    return isInCurrentRow(data.id) || 
      data.metaData.filter(item => isInCurrentRow(item.id)).flat(Infinity).length > 0
  };

  const isInCurrentRow = (id) => {
    
    if (!globalState.state.formData.currentRow) return false
    return globalState.state.formData.currentRow.filter(row => row.dataGridId == props.data.id && row.id == id).length > 0
  };
  const getCurrentRowTemplate = (template) => {
    if (template.type == "Row")  
      return template
    else {
      var parent = []
      
      getCurrentsTools({metaData:rowData}, parent, [template.parentId[0]]);
      
      if (parent[0] && parent[0].type == "Row")
        return parent[0]
      else
        return undefined
    }
  };

  const onToolComponentClick = (e, template) => {
    
    props.onClick(e, {dataGridId:props.data.id, rowTemplate:getCurrentRowTemplate(template), ...template})
    
    /*var updatedFormData = JSON.parse(
      JSON.stringify(globalState.state.formData)
    );
    if (!updatedFormData.currentRow) {
      updatedFormData.currentRow = [{gridId:props.data.id, row:template}]
     
      dispatch({
        type: "UPDATE_FORM_WITOUT_HISTORIQUE",
        payload: updatedFormData,
      });
    }
    else { //if (updatedFormData.currentRow.filter(row => row.gridId == props.data.id && row.row.id == template.id).length == 0) {
      
      updatedFormData.currentRow = updatedFormData.currentRow.filter(row => row.gridId != props.data.id)
      updatedFormData.currentRow.push({gridId:props.data.id, row:template})
      dispatch({
        type: "UPDATE_FORM_WITOUT_HISTORIQUE",
        payload: updatedFormData,
      });

    }*/

    //setCurrentRow({id:template.id})
    
  };
  
  const getToolComponent = (data, index=undefined) => {
    
    const isHeader = data.type == "Header"
    const isSearchGrid = data.type == "SearchGrid"
    const isRows = data.type == "Rows"
    const isRow = data.type == "Row"
    
    return  <ToolComponent key = {data.id}
              position={"relative"}
              meta={{ ...data, selectedValues: props.data.selectedValues
                , parent:{id:props.data.id, styles: props.data.styles}
                , pagination:isSearchGrid ? pagination: undefined
                , allColums:isSearchGrid ? getColumns(): undefined
                , isCurrentRow:isRows ? true : isRow ? isCurrentRow(data) : undefined
                , index:index
                //, metaData: props.data.metaData.filter(item => item.type == data.type)[0].metaData
              }}
              draggable={props.draggable}
              // draggable={isHeader}
              //onlyLabel={isHeader}
              dataGridColumn={true}
              onSelectOperator={(details) => onSelectOperator(details)}
              
              onDropColumn={(e, column) => onDropColumn(e, column, props.data.id)}
              onDragStart={(e) => props.onDragStart(e)}
              handleOnDrop={(updatedFormData,containerId, currentTemplate) => 
              props.handleOnDrop(updatedFormData,containerId, currentTemplate)}
              updateSize ={(id, resizeWidth, resizeHeight) => updateSize(id, resizeWidth, resizeHeight, isHeader)}
              onClickPagination ={(newPagination) => onClickPagination(newPagination)}
              onMultiselectionClick={(itemSelected) =>
                onMultiselectionClick(itemSelected)
              }
              onChange={(e, value) => props.onChange(e, value)}
              onKeyPress={(e) => props.onKeyPress(e)}
              onBlur={(e, currentTemplate) => props.onBlur(e, currentTemplate)}
              //onMouseOver={(e, currentTemplate) => props.onMouseOver(e, currentTemplate)}
              onMouseEnter={(e, currentTemplate) => props.onMouseEnter(e, currentTemplate)}
              onMouseDown={(e, currentTemplate) => props.onMouseDown(e, currentTemplate)}
              onMouseLeave={(e, currentTemplate) => props.onMouseLeave(e, currentTemplate)}
              onClick={(e, currentTemplate) => onToolComponentClick(e, currentTemplate)}
              onClickAdd={(e, index) => onClickAdd(e, index)}
              onClickRemove={(e, rowId) => onClickRemove(e, rowId)}
              add={props.data.properties.add.value}
              delete={props.data.properties.delete.value}
              onDoubleClick={(e, currentTemplate) => onDoubleClick(e, currentTemplate)}
              />
  };

  const showItem = (type, data) => {
  
    if (type == "Rows")
      return getToolComponent(data, 0)
    if (type == "Row") {
      return getCurrentRow().map((row, index) => getToolComponent(row, index))
    }
    else
      return  getToolComponent(data)
  };

  
  return (  
    
      <div
        draggable={props.draggable}
        onDrop={(e) => drop(e, props.data.id)}
        onDragEnter={(e) => onDrag(e, true)}
        onDragStart={(e) => props.onDragStart(e)}
        onDragLeave={(e) => onDrag(e, false)}
        onClick={(e) => onClick(e, props.data.id)}
        id={props.data.id}
        key={props.data.id}
        style={getStyle()}
       // onScroll={(e) => setWidth(e)}
        >
          {props.data.properties.search.value && showItem("SearchGrid", searchGridData)}
          {props.data.properties.header.value && showItem("Header", headerData)}
          {props.data.properties.filter.value && showItem("Filter", filterData)}
          {rowData.length == 0 && showItem("Rows", rowsData)}
          {rowData.length > 0 && showItem("Row", rowData)}
      </div>
     
  );
}
